module.exports = __webpack_public_path__ + "static/media/hi_mid.d3cc0b71.png";